import { NgModule } from "@angular/core";
import { ToggleFormComponent } from './toggle-form/toggle-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { DynamicToggleComponent } from './dynamic-toggle.component';
import { ToggleDesignComponent } from './toggle-design/toggle-design.component';
import { ToggleResultComponent } from './toggle-result/toggle-result.component';
import { KendoModule } from '../kendo.module';

@NgModule({
    declarations: [
        ToggleFormComponent, DynamicToggleComponent, ToggleDesignComponent, ToggleResultComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        KendoModule
    ],
    entryComponents: [
        DynamicToggleComponent
    ]
})
export class ToggleModule {}